import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// CSRF tokens are kept in memory only. The authentication token is held by
// the backend's HttpOnly cookie and is never readable by JavaScript.
let csrfToken = "";

export const setCsrfToken = (token) => {
  csrfToken = typeof token === "string" ? token : "";
};

export const clearAdminAuth = () => {
  csrfToken = "";
  // Remove tokens written by older releases from both browser stores.
  for (const storeName of ["localStorage", "sessionStorage"]) {
    try {
      const store = window[storeName];
      store.removeItem("pmt_admin_token");
      store.removeItem("pmt_admin_csrf");
    } catch {
      // Browser storage may be unavailable in private browsing modes.
    }
  }
};

// Retained as a compatibility export for any remaining imports. Tokens are
// deliberately not persisted; authentication is cookie-based.
export const setAdminToken = () => true;
export const getAdminToken = () => "";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (csrfToken && !["get", "head", "options"].includes(String(config.method || "get").toLowerCase())) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

export default api;
